module.exports = { 
    BLEND_ADDRESS: "Street 36 Silk Bank Plaza Lower Basement WorkZone,MPCHS E 11/3 E-11, Islamabad, Islamabad Capital Territory",
    BLEND_CONTACT: "+92 336 5300959",
    BLEND_EMAIL: "hasnain@letsblendit.com",
    // social media links
    BLEND_FACEBOOK: "https://www.facebook.com",
    BLEND_LINKEDIN: "https://www.linkedin.com",
    BLEND_TWITTER: "https://www.twitter.com",
    BLEND_REDDIT: "https://www.reddit.com",
    // URL used to share among the social media
    BLEND_URL: "https://github.com/ch-Arham",
}